import Prismic from '@prismicio/client'
import { ApolloClient, InMemoryCache } from '@apollo/client'
import { PrismicLink } from 'apollo-link-prismic'

const cache = new InMemoryCache()

const makeApolloClient = () => {
  return new ApolloClient({
    link: PrismicLink({
      uri: `https://${process.env.REACT_APP_PRISMIC_REPO}.cdn.prismic.io/graphql`
      // accessToken: "YOUR ACCESS TOKEN IF YOUR API IS PRIVATE"
    }),
    cache
  })
}

/**
 * Send graphql queries using Apollo client
 */
export const apolloPrismicClient = makeApolloClient()

/**
 * Prismic REST Client
 */
export const prismicClient = Prismic.client(`https://${process.env.REACT_APP_PRISMIC_REPO}.cdn.prismic.io/api/v2`)
